/**
 * TeacherSchedule — Region schedule (`/me/region-schedule`). Everyone's
 * workshops in the teacher's assigned region(s), with their own picked out
 * and clickable; a calendar on desktop/tablet, a terse list on a phone.
 */
import { useViewport } from '../../../hooks/useViewport';

import TeacherRegionScheduleDesktop from './components/TeacherRegionScheduleDesktop';
import TeacherRegionSchedulePhone from './components/TeacherRegionSchedulePhone';

export default function TeacherSchedule() {
  const { isPhone } = useViewport();
  if (isPhone) return <TeacherRegionSchedulePhone />;
  return <TeacherRegionScheduleDesktop />;
}
